import { Text, View, Image } from "reshaped";
import { CertificateItemProps } from "./CertificateItem.types";

export const CertificateItem = (props: CertificateItemProps) => {
  const { list } = props;
  return (
    <View
      direction="column"
      padding={6}
      borderColor="neutral"
      borderRadius="medium"
    >
      <Image displayMode="contain" src={list.img} height={70} width="100%" />
      <View paddingTop={6} paddingBottom={1} height={20}>
        <Text variant="body-2" weight="bold" maxLines={2}>
          {list.title}
        </Text>
      </View>

      <Text variant="body-3">{list.description}</Text>
    </View>

  );
};
